import React, { useState, useEffect, useCallback } from 'react';
import { endpoints } from '../api';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    // 1. Get saved data immediately
    const savedEmail = localStorage.getItem('remembered_email') || "";
    const savedPass = localStorage.getItem('remembered_pass') || "";

    const [email, setEmail] = useState(savedEmail);
    const [pass, setPass] = useState(savedPass);
    const navigate = useNavigate();

    // Wrap handleLogin in useCallback so it can be used in useEffect safely
    const handleLogin = useCallback(async (loginEmail = email, loginPass = pass) => {
        try {
            const res = await endpoints.login({ email: loginEmail, password: loginPass });
            
            // Save everything to localStorage
            localStorage.setItem('remembered_email', loginEmail);
            localStorage.setItem('remembered_pass', loginPass);
            localStorage.setItem('user_email', res.data.email);
            
            // Save metadata if it exists in response
            if (res.data.industry) localStorage.setItem('user_industry', res.data.industry);
            if (res.data.company) localStorage.setItem('user_company', res.data.company);

            navigate('/dashboard');
        } catch (e) {
            // If auto-login fails, clear the saved pass so the user can re-try manually
            console.error("Login failed");
        }
    }, [email, pass, navigate]);

    // 2. AUTO-LOGIN TRIGGER
    useEffect(() => {
        if (savedEmail && savedPass) {
            handleLogin(savedEmail, savedPass);
        }
    }, [handleLogin, savedEmail, savedPass]);

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Login</h2>
                <p className="subtitle">Welcome back! Please enter your details.</p>
                
                <div className="input-group">
                    <label>Email Address</label>
                    <input 
                        type="email"
                        value={email}
                        placeholder="email@example.com" 
                        onChange={e => setEmail(e.target.value)} 
                    />
                </div>

                <div className="input-group">
                    <label>Password</label>
                    <input 
                        type="password" 
                        value={pass}
                        placeholder="••••••••" 
                        onChange={e => setPass(e.target.value)} 
                    />
                </div>

                <button className="btn-primary" onClick={() => handleLogin()}>
                    Login
                </button>

                <p className="footer-link">
                    Don't have an account? <span onClick={() => navigate('/register')}>Register</span>
                </p>
            </div>
        </div>
    );
};

export default Login;